export default "__VITE_ASSET__BQUZquXA__"